import React from "react";
import { Image } from "@chakra-ui/react";

const LazyImage = (props) => <Image {...props} />;


export default LazyImage;
